class createTicketTemplate {
    constructor($state) {
        this.key = 'create-ticket-template';
        this.title = 'Create new template';
        this.level = 'highlight';
        this.icon = 'plus-circle';
        this.order = 10;
        this.state = $state;
    }

    action({}, store) {
        return this.state.go('app.tickets.templates.create', {store: store, backParams: {store: store}});
    }
}

angular
    .module('festzelt-os.modules.tickets.templates')
    .factory('createTicketTemplate', [
        '$state',
        $state => new createTicketTemplate($state)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/tickets/templates/workflows/list/create-ticket-template.js